import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Overflow extends BaseOption {
  static userInterfaceComponent = {
    label: "Overflow",
    component: inspectorTools.AUTOCOMPLETE,
    props: {
      showAllResultsOnClick: true,
      items: [
        {
          value: "auto",
          label: "Auto",
        },
        {
          value: "scroll",
          label: "Scroll",
        },
        {
          value: "hidden",
          label: "Hidden",
        },
        {
          value: "visible",
          label: "Visible",
        },
        {
          value: "none",
          label: "None",
        },
      ],
      itemValueKey: "value",
      itemLabelKey: "label",
      prefix: "O:",
    },
  };

  static defaultValue = "none";
}
